// extracted by mini-css-extract-plugin
module.exports = {"root":"stack_root__2cNxu"};